import * as React from 'react'
import { ImageBase, Label, Link, PrimaryButton, Stack, TextField, Image, DefaultButton } from '@fluentui/react';
import { useTranslation } from 'react-i18next';
import '../../../css/components/login.scss';
import *  as Api from '../../../api/src';
import styled from 'styled-components';
import ErrorMesage from '../../../control/MessageBar/Error';
import { useHistory } from "react-router-dom";
import { commonfn } from '../../../common/commonfn';
import { ToastAppMsgContext } from '../../../context/toastApp.Context';
import { ToastAppType } from '../../../common/constant/enum/toastAppType';
const LoginStyle = styled.div`
display: flow-root;
.login-stackItem{
    margin-top:250px;
}
.ms-md2{
    min-width:250px;
    margin-bottom: 12px;

}
.footer-page{
    text-align: center;
    position: fixed;
    bottom: 0;
    width: 100%;
    img{
        margin: 10px;
    }
}
`;
// Create an instance of PublicClientApplication
const UserApi = new Api.UserApi()
const ResetPassword = () => {
    const { t } = useTranslation();
    let routerHistory = useHistory();
    const [detail, SetDetail] = React.useState<Api.ResetPasswordRequest>({
        Password: "",
        ConfirmPassword: "",
        Token: ""
    })
    const [ResetErrorMessage, SetResetErrorMessage] = React.useState('');
    const { setToastData } = React.useContext(ToastAppMsgContext);
    const [re_passwordErrorMessage, SetRepasswordErrorMessage] = React.useState('');
    const [passwordErrorMessage, SetPasswordErrorMessage] = React.useState('');
    React.useEffect(() => {
        SetResetErrorMessage("");
        SetRepasswordErrorMessage("");
        SetPasswordErrorMessage("");
        let token = commonfn.getParramUrl(window.location.href, "Token");
        SetDetail({ ...detail, Token: token || "" })
    }, [])
    const validateFormData = () => {
        let pass = true;
        if (!detail?.Token) {
            pass = false;
        }
        if (!detail?.Password) {
            SetPasswordErrorMessage(t("IsRequired").replace("{0}", t("NewPassword")));
            pass = false;
        }

        if (!detail?.ConfirmPassword) {
            SetRepasswordErrorMessage(t("IsRequired").replace("{0}", t("RePassword")));
            pass = false;
        }
        if (detail?.Password && detail?.ConfirmPassword && detail?.Password != detail?.ConfirmPassword) {
            SetPasswordErrorMessage(t("PasswordAndConfirmPasswordNotMatch"));
            SetRepasswordErrorMessage(t("PasswordAndConfirmPasswordNotMatch"));
            pass = false;
        }
        if (detail?.Password && detail.Password.length < 6) {
            SetPasswordErrorMessage(t("PasswordMustBeAtLeast6Characters"));
            pass = false;
        }
        return pass;
    }
    const btnSubmit_click = async () => {
        if (!validateFormData()) {
            return;
        }
        let data = await UserApi.apiUserResetPasswordPost(detail);
        if (!data || data?.status != 200) return;
        if (data.data.Messages && data.data.Messages?.length > 0 && data.data.Messages[0] == "EmailNotExist") {
            SetResetErrorMessage(t("EmailNotExist"));
            return;
        }
        setToastData({ Message: t("Successed"), Type: ToastAppType.Success });
    }

    return (
        <LoginStyle>
            <Stack verticalAlign={'center'} className={"login-stackItem ms-Grid"} horizontalAlign={'center'}  >
                <div className="ms-Grid-row  ms-Grid-col margin-0 ms-md3">
                    <b> {t("CreateNewPassword")}</b>
                </div>
                <div className="ms-Grid-row  ms-Grid-col margin-0 ms-md3">
                    {t("PleaseEnterYourNewPassword")}
                </div>
                <div className="ms-Grid-row  ms-Grid-col margin-0 ms-md3">
                    <ErrorMesage Message={ResetErrorMessage} onClose={() => { SetResetErrorMessage('') }} />
                </div>
                <div className={"ms-Grid-row  ms-Grid-col ms-md3 "}>
                    <TextField type="password" autoFocus={true} errorMessage={passwordErrorMessage} label={t("Password") + " (*)"} value={detail.Password || ""}
                        onChange={(e, newValue) => {
                            SetDetail({ ...detail, Password: (newValue || "").toString() });
                            SetPasswordErrorMessage("");
                        }} ></TextField>
                </div>
                <div className={"ms-Grid-row  ms-Grid-col ms-md3 "}>
                    <TextField type="password" errorMessage={re_passwordErrorMessage} label={t("RePassword") + " (*)"} value={detail.ConfirmPassword || ""}
                        onChange={(e, newValue) => {
                            SetDetail({ ...detail, ConfirmPassword: (newValue || "").toString() });
                            SetRepasswordErrorMessage("");
                        }}
                    ></TextField>
                </div>
                <div className="ms-Grid-row  ms-Grid-col ms-md3">
                    <PrimaryButton text={t('Submit')} onClick={btnSubmit_click} />
                </div>
            </Stack>
            <div className={"footer-page"}>
                <img style={{ height: 30 }} src='/images/logo.png'></img>
            </div>
        </LoginStyle>
    );
}
export default ResetPassword;